import {VARIANTS} from "@components/ui/constants";

const overrideTableStyles = theme => ({
  MuiTableContainer: {
    styleOverrides: {
      root: {
        position: 'relative'
      }
    }
  },

  MuiTableRow: {
    styleOverrides: {
      root: {
        '&.Mui-selected': {
          backgroundColor: theme.palette.action.selected,
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        }
      }
    }
  },

  MuiTableCell: {
    styleOverrides: {
      head: {
        color: theme.palette.text.secondary,

        span: {
          justifyContent: 'center'
        }
      },
      paddingCheckbox: {
        paddingLeft: theme.spacing(1)
      },
      footer: {
        borderTop: `solid 1px ${theme.palette.divider}`
      }
    }
  },

  MUIDataTableToolbar: {
    styleOverrides: {
      filterPaper: {
        minWidth: "40%"
      },

      actions: {
        ".MUIDataTableToolbar-customActions": {
          paddingTop: 20,
          borderTop: "1px solid",
          borderColor: theme.palette.divider
        }
      }
    }
  },

  MUIDataTableFilter: {
    defaultProps: {
      MuiButton: {
        variant: VARIANTS.OUTLINED,
        size: 'small'
      }
    },

    styleOverrides: {
      resetLink: {
        backgroundColor: 'transparent',
        color: theme.palette.text.secondary,

        ":hover": {
          backgroundColor: 'transparent',
          color: theme.palette.text.primary,
          boxShadow: 'none'
        }
      }
    }
  },

  MuiTablePagination: {
    styleOverrides: {
      toolbar: {
        overflow: 'hidden',
        height: 64
      },
      actions: {
        marginRight: theme.spacing(1)
      },
      select: {
        '&:focus': {
          borderRadius: theme.shape.borderRadius
        }
      }
    }
  }
})

export default overrideTableStyles